import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Dropdown from "react-bootstrap/Dropdown";
import logo from "../assets/images/logo.png";
import menuLeft from "../assets/images/menu-left.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Store from "../zustand/store";
import { BASEURL } from "../constant/constant";
import helper from "../helper/authHelper";
import useFetch from "../hook/useFetch";
import Impersonation from "./Admin/impersonation/Impersonation";
import { useImpersonation } from "../hook/useImpersonation";

const Navbar = (props) => {
  const userData = useSelector((st) => st?.user);
  const userSubscription = useSelector((st) => st?.user?.subscription);
  const { handleStopImpersonating } = useImpersonation();

  let Username = JSON.parse(localStorage.getItem("Username"));
  const { pathname } = useLocation();
  let validates = false;
  const [isLandPage, setIsLandPage] = useState("true");
  let user = JSON.parse(localStorage.getItem("LogUser"));
  let Fname = JSON.parse(localStorage.getItem("fname"));
  const navigate = useNavigate();
  const [, , , fetchData] = useFetch();

  let memberStatusStorage = localStorage.getItem("MemberStatus");
  const isCurrentlyImpersonating =
    localStorage.getItem("impersonating") || false;

  const { MemberType } = props;

  const { memberStatus } = Store();

  user ? (validates = true) : (validates = false);

  // Navbar titles
  const navArr = [
    { path: "/", title: "Home" },
    { path: "/user/testimonial", title: "Testimonial" },
    { path: "/user/research", title: "Research" },
    { path: "/user/subscription", title: "Subscribe" },
    { path: "/user/managegroup", title: "Manage Group" },
    { path: "/institute", title: "Manage Institute" },
    { path: "/research/information", title: "Information" },
  ];

  useEffect(() => {
    pathname === "/" ? setIsLandPage(true) : setIsLandPage(false);
  }, [pathname]);

  const URL = `/check/auth?Username=${Username}`;
  // Get Information
  const getData = async () => {
    try {
      const allInfo = await fetchData({
        url: URL,
        method: "get",
        headers: {
          "Content-Type": "application/json",
          authorization: JSON.parse(localStorage.getItem("LogUser")),
        },
      });
      if (allInfo?.status === 401) {
        if (isCurrentlyImpersonating) {
          await handleStopImpersonating();
        } else {
          helper(navigate);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        getData();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const location = useLocation();

  const isUserTypeMismatch = (path, userType) => {
    return (
      (path === "/institute" && userType !== "institute") ||
      (path === "/institute/professor" && userType !== "professor") ||
      (path === "/user/managegroup" &&
        (userType === "institute" || userType === "professor"))
    );
  };

  const handleLogout = async () => {
    if (isCurrentlyImpersonating) {
      await handleStopImpersonating();
    } else {
      navigate("/logout");
    }
  };

  const getInTouchDropOptions = [
    { path: "/contact-us", title: "Contact Us" },
    { path: "/connect-with-us", title: "Social Media" },
    { path: "/faq", title: " FAQ's" },
    { path: "/blogs", title: "Blogs" },
  ];

  return (
    <>
      <header style={{ display: "none" }}>
        <nav className="navbar navbar-expand-md main-header-section">
          <div className="container-fluid">
            <a className="navbar-brand" href="/">
              <div className="logoContent ">
                <img src={logo} alt="" className="img-fluid" />
              </div>
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mynavbar"
            >
              <img src={menuLeft} alt="" />
            </button>
            <div className="collapse navbar-collapse" id="mynavbar">
              <ul className="navbar-nav ms-auto">
                {navArr?.map((item, index) => {
                  if (
                    (item.path === "/institute" && !userSubscription) ||
                    (item.path === "/institute/professor" &&
                      !userSubscription) ||
                    isUserTypeMismatch(item?.path, userData?.user?.userType)
                  ) {
                    return null;
                  } else if (
                    item.path === "/user/managegroup" &&
                    (userData?.user?.userType === "child" ||
                      userData?.user?.userType === "ios")
                  ) {
                    return null;
                  } else if (
                    (!user && item.path === "/user/managegroup") ||
                    (Username && item.path === "/user/managegroup")
                  ) {
                    return null;
                  } else if (
                    ((memberStatus === "ACTIVE" ||
                      memberStatusStorage === "ACTIVE") &&
                      (MemberType === "monthly" ||
                        MemberType === "yearly" ||
                        MemberType == "EMPTY") &&
                      item.path == "/user/managegroup") ||
                    ((memberStatus === "EMPTY" ||
                      memberStatus == null ||
                      memberStatusStorage == "EMPTY" ||
                      memberStatusStorage == null) &&
                      item.path == "/user/managegroup")
                  ) {
                    return null;
                  } else {
                    return (
                      <li
                        key={index + "ind"}
                        className={
                          item?.path === pathname
                            ? "nav-item text-underline"
                            : "nav-item"
                        }
                      >
                        <Link className="nav-link " to={item.path}>
                          {item.title}
                        </Link>
                      </li>
                    );
                  }
                })}

                <li className="nav-item">
                  <Dropdown className="award-dropdown cstm-award-drpdwn">
                    <Dropdown.Toggle
                      variant="transparent"
                      id="dropdown-basic"
                      className="fw-medium"
                    >
                      Get in Touch
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="cstm-nav-link">
                      <Dropdown.Item
                        as={Link}
                        to="/contact-us"
                        className={
                          location.pathname === "/contact-us"
                            ? "nav-item subActive  "
                            : ""
                        }
                      >
                        Contact Us
                      </Dropdown.Item>
                      <Dropdown.Item
                        as={Link}
                        to="/connect-with-us"
                        className={
                          location.pathname === "/connect-with-us"
                            ? "subActive"
                            : ""
                        }
                      >
                        Social Media
                      </Dropdown.Item>
                      <Dropdown.Item
                        as={Link}
                        to="/faq"
                        className={
                          location.pathname === "/faq" ? "subActive" : ""
                        }
                      >
                        FAQ's
                      </Dropdown.Item>
                      <Dropdown.Item
                        as={Link}
                        to="/blogs?currentPage=1"
                        className={
                          location.pathname === "/blogs" ? "subActive" : ""
                        }
                      >
                        Blogs
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>

                <li className="nav-item">
                  <Dropdown className="award-dropdown">
                    <Dropdown.Toggle
                      variant="transparent"
                      id="dropdown-basic"
                      className="fw-medium"
                    >
                      Achievement
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="/liveInk/awards">
                        Awards
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
              </ul>

              {/* Doesent neeed */}
              <div className="userTop ms-auto">
                <div className="dropdown">
                  {validates ? (
                    <>
                      <button
                        type="button"
                        className="btn dropdown-toggle d-flex gap-2 align-items-center "
                        data-bs-toggle="dropdown"
                      >
                        <div className="nav-userprofile">
                          <img
                            src={
                              userData?.user?.profileUrl.startsWith("https")
                                ? userData?.user?.profileUrl
                                : `${BASEURL}/${userData?.user?.profileUrl}`
                            }
                            alt=""
                          />
                        </div>
                        <span>
                          {Fname ||
                            userData?.user?.instituteName ||
                            userData?.user?.Lname}
                        </span>
                      </button>
                      <ul className="dropdown-menu">
                        <Link className="dropdown-item" to="/user/profile">
                          My Profile
                        </Link>
                        {userData?.user?.userType === "institute" && (
                          <Link
                            className="dropdown-item"
                            to="/institute/settings"
                          >
                            Settings
                          </Link>
                        )}
                        <button
                          className="dropdown-item"
                          onClick={handleLogout}
                        >
                          Logout
                        </button>
                      </ul>
                    </>
                  ) : (
                    <>
                      {!isLandPage ? (
                        <>
                          <div className="gstarted">
                            <Link className="get-str text-center" to="/login">
                              {" "}
                              Login
                            </Link>
                            <Link
                              className="get-str text-center"
                              to="/registration"
                            >
                              {" "}
                              Sign Up
                            </Link>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>

      <section className="header_wrapper">
        <div className="container">
          <nav className="navbar navbar-expand-xxl navbar-light">
            <div className="container-fluid">
              <Link className="navbar-brand logo_wrapper order-1" to="/">
                <img src={logo} alt="Logo" className="img-fluid" />
              </Link>
              <button
                className="navbar-toggler order-3"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className="collapse navbar-collapse order-xxl-2"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav mx-auto nav_item_wrap gap-2">
                  {navArr?.map((item, index) => {
                    if (
                      (item.path === "/institute" && !userSubscription) ||
                      (item.path === "/institute/professor" &&
                        !userSubscription) ||
                      isUserTypeMismatch(item?.path, userData?.user?.userType)
                    ) {
                      return null;
                    } else if (
                      item.path === "/user/managegroup" &&
                      (userData?.user?.userType === "child" ||
                        userData?.user?.userType === "ios")
                    ) {
                      return null;
                    } else if (
                      (!user && item.path === "/user/managegroup") ||
                      (Username && item.path === "/user/managegroup")
                    ) {
                      return null;
                    } else if (
                      ((memberStatus === "ACTIVE" ||
                        memberStatusStorage === "ACTIVE") &&
                        (MemberType === "monthly" ||
                          MemberType === "yearly" ||
                          MemberType == "EMPTY") &&
                        item.path == "/user/managegroup") ||
                      ((memberStatus === "EMPTY" ||
                        memberStatus == null ||
                        memberStatusStorage == "EMPTY" ||
                        memberStatusStorage == null) &&
                        item.path == "/user/managegroup")
                    ) {
                      return null;
                    } else {
                      return (
                        <li className="nav-item" key={index + "ind"}>
                          <Link
                            className={`nav-link ${
                              location.pathname === item.path ? "active" : ""
                            }`}
                            to={item.path}
                          >
                            {item.title}
                          </Link>
                        </li>
                      );
                    }
                  })}

                  <li className="nav-item dropdown list_dropdown">
                    <a
                      className={`nav-link dropdown-toggle ${
                        [
                          "/contact-us",
                          "/faq",
                          "/connect-with-us",
                          "/blogs",
                        ].includes(location.pathname)
                          ? "active"
                          : ""
                      }`}
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Get in Touch
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown"
                    >
                      {getInTouchDropOptions?.map((item, index) => (
                        <li key={index + "ind"}>
                          <Link
                            className={`dropdown-item ${
                              location.pathname === item.path ? "active" : ""
                            }`}
                            to={item?.path}
                          >
                            {item.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                  <li className="nav-item dropdown list_dropdown">
                    <a
                      className={`nav-link dropdown-toggle ${
                        location.pathname === "/liveInk/awards" ? "active" : ""
                      }`}
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Achievement
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown"
                    >
                      <li>
                        <Link
                          className={`dropdown-item ${
                            location.pathname === "/liveInk/awards"
                              ? "active"
                              : ""
                          }`}
                          to={"/liveInk/awards"}
                        >
                          Awards
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div className="login_btn order-2 order-xxl-3 ms-auto me-3 me-xxl-0">
                <ul className="navbar-nav mx-auto nav_item_wrap gap-2">
                  <li className="nav-item">
                    {validates ? (
                      <div className="user_flex">
                        <img src="https://uatapp.readmax.com/static/media/loginImg.c708d47911264cd4e74f.png" />
                        <button className="nav-link" onClick={handleLogout}>
                          Logout
                        </button>
                      </div>
                    ) : (
                      <Link className="nav-link" to={"/login"}>
                        Login
                      </Link>
                    )}
                  </li>
                  {/* <li className="nav-item">
                    <a className="nav-link theme_btn" href="#">
                      Get Started Free
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </section>

      <Impersonation
        isCurrentlyImpersonating={isCurrentlyImpersonating}
        currentUser={userData?.user}
      />
    </>
  );
};

export default Navbar;
